import { render, staticRenderFns } from "./InspectionsWeekCompletionsTable.vue?vue&type=template&id=1934b4d2&scoped=true"
import script from "./InspectionsWeekCompletionsTable.vue?vue&type=script&lang=js"
export * from "./InspectionsWeekCompletionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934b4d2",
  null
  
)

export default component.exports